import { Pipe, PipeTransform } from '@angular/core';


@Pipe({
  name: 'scrCourseFilter'
})
export class SCRCoursePipe implements PipeTransform {

  transform(arrayObj: any[], requirementId: number): any {
    return arrayObj.filter(x => x.DistrictRequirement_ID == requirementId);
  }

}
